import { Suspense, lazy } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

// "Become a provider" entry point.
//
// Default: the friction-free CategoryFirstOnboarding — pick a category,
// the platform scaffolds a DRAFT shop from a category template (business
// name, bio, suggested services + prices) and the provider lands on the
// dashboard ready to customise.
//
// Escape hatch: append `?wizard=1` to reach the legacy 5-step
// ProviderOnboardingWizard for providers who prefer manual entry.
//
// Both children are lazy-loaded so the bulk of this route's MUI surface
// (Grid, ToggleButtonGroup, Stepper, country-state-city via LocationPicker)
// is fetched only when the user actually visits /become-provider. Keeping
// them eager pushed the home-page first-paint past the 6s boot watchdog
// (see index.html) because App.tsx statically imports this page.
const CategoryFirstOnboarding = lazy(() =>
  import('./CategoryFirstOnboarding').then((m) => ({ default: m.CategoryFirstOnboarding })),
);
const ProviderOnboardingWizard = lazy(() =>
  import('./ProviderOnboardingWizard').then((m) => ({ default: m.ProviderOnboardingWizard })),
);

function Spinner() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress />
    </Box>
  );
}

export function BecomeProviderPage() {
  const [params, setParams] = useSearchParams();
  const useWizard = params.get('wizard') === '1';

  if (useWizard) {
    return (
      <Suspense fallback={<Spinner />}>
        <ProviderOnboardingWizard />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<Spinner />}>
      <CategoryFirstOnboarding
        onUseWizard={() => {
          const next = new URLSearchParams(params);
          next.set('wizard', '1');
          setParams(next, { replace: true });
        }}
      />
    </Suspense>
  );
}
